import { PageController } from '@client/components/_core/layout/PageController';
import { AddConnectionDrawer } from '@client/components/document-sources/AddConnectionDrawer';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/configuration/api-integrations/document-sources/add')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Add connection',
        },
    },
    component: AddConnectionRoute,
});

function AddConnectionRoute() {
    const { orgId } = Route.useParams();
    const navigate = useNavigate();

    return (
        <PageController route={Route}>
            <AddConnectionDrawer
                afterClose={() => void navigate({ moveInMatches: -1 })}
                onOpenChecklist={(connection) =>
                    void navigate({
                        to: '/console/$orgId/configuration/api-integrations/document-sources/$connectionId',
                        params: { orgId, connectionId: connection.id },
                        replace: true,
                    })
                }
            />
        </PageController>
    );
}
